import React, { useEffect, useRef, useState } from "react";
import SearchableDropdown from "../FormComponent/Contact/SearchableDropdown";
import useLocationApi from "../../../hooks/useLocationApi";
import { Controller } from "react-hook-form";
import { Input } from "reactstrap";
import { MobileNoInputContainer } from "./MobileNoInputContainer";
import { useDispatch, useSelector } from "react-redux";
import {
  setContactMobNo,
  setPhoneNo,
} from "../../../store/Contact/phoneNoSlice";
import { COUNTRY_CDN_URL } from "../../../utils/constant";
import { CountryListAaray, CountryLists } from "../../../pages/Contact/EditContact/EditContactSchema";
import { MobileNoInputFields } from "../FormComponent/Contact/FormComponentSchema";

const MobileNoInputField: React.FC<MobileNoInputFields> = ({
  inputName,
  name,
  control,
  labelName = "Contact No",
  newContactCreatedDetail,
  placeHolder,
  handleBlur,
  index ,
  fetchInitialData,
  setValue,
}) => {
  const dispatch = useDispatch();

  const phoneNo = useSelector((state: any) => state.phoneNo);
  const sessionList = useSelector((state: any) => state.sessionData.sessionScope);

  const [value1, setValue1] = useState<CountryLists>({
    countriesCode: "IN",
    countriesId: 101,
    countriesName: "India",
    countryDialCodePrefix: 91,
    countryImageName: "in.svg",
    currencyCode: "Rs.",
    currencyName: "Rupees",
    currencySymbol:
      '<i class="fa fa-inr currency_style" aria-hidden="true"></i>',
    isbrnrequired: 0,
  });

  // State for dropdown toggles
  const [isCountryDropdownOpen, setIsCountryDropdownOpen] = useState<boolean>(
    false
  );
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [countries, setCountries] = useState<CountryLists[]>([]);


  const { getCountryList } = useLocationApi();

  const inputRef = useRef(null);

  const countryDropdownHandler = () => {
    setIsOpen(!isOpen);
    setIsCountryDropdownOpen(!isCountryDropdownOpen);
  };
 
  useEffect(() => {
    (async () => {
      const countryList = await getCountryList();
        const parsedResult = CountryListAaray.safeParse(countryList?.response);
        if (parsedResult.success && countryList?.response?.length > 0) {
          setCountries(countryList?.response)
         } else {
          console.error("Parsing error:",countryList?.response);
          console.error("Parsing error:", parsedResult.error);
        }
       })();
  }, []);

  const countryImage = countries?.find(
    (co) => co.countryDialCodePrefix == phoneNo?.prefixes[inputName]
  );
 
  useEffect(() => {
    const inputValue = () => {
      if (inputName === "mobNo") {
        if (
          newContactCreatedDetail?.ContactDetails?.countryDialCodePrefix !=
          phoneNo?.prefixes?.mobNo &&
          phoneNo?.prefixes?.mobNo != "91"
        ) {
          return phoneNo?.prefixes?.mobNo;
        } else {
          return (
            newContactCreatedDetail?.ContactDetails?.countryDialCodePrefix ||
            "91"
          );
        }
      } else if (inputName === "whatsappNo") {
        if (
          newContactCreatedDetail?.ContactDetails
            ?.countryDialCodePrefixWhatsapp != phoneNo?.prefixes?.whatsappNo &&
          phoneNo?.prefixes?.whatsappNo != "91"
        ) {
          return phoneNo?.prefixes?.whatsappNo;
        } else {
          return (
            newContactCreatedDetail?.ContactDetails
              ?.countryDialCodePrefixWhatsapp || "91"
          );
        }
      }
    };

    dispatch(
      setPhoneNo(
        newContactCreatedDetail && {
          inputName: inputName,
          value: inputValue(),
        }
      )
    );
  }, []);


  useEffect(() => {
    if (newContactCreatedDetail?.ContactDetails) {
      newContactCreatedDetail?.ContactDetails?.contactAddress?.forEach((detail, index) => {
        const prefix = phoneNo?.prefixes?.[`addressDetailsmobNo[${index}]`];
        if (
          prefix &&
          detail?.countryDialCodePrefix !== prefix 
        ){
          dispatch(
            setContactMobNo({
              inputName: `addressDetailsmobNo[${index}]`,
              value: phoneNo?.prefixes[`addressDetailsmobNo[${index}]`],
            })
          );
        } else {
          dispatch(
            setContactMobNo({
              inputName: `addressDetailsmobNo[${index}]`,
              value: detail?.countryDialCodePrefix,
            })
          );
        }
      });
    } else {
      dispatch(
        setContactMobNo({
          inputName: `addressDetailsmobNo[${0}]`,
          value: phoneNo?.prefixes[`addressDetailsmobNo[${0}]`] || "91",
        })
      );
    }
  }, [newContactCreatedDetail]);
  

  const defaultCity = sessionList?.cityCode || "938";
  const defaultState = sessionList?.stateCode || "24";

  const handleMobileChange = (val: CountryLists) => {
    if (typeof val === "object") {
      fetchInitialData &&
      fetchInitialData(
        "value",
        val.countriesCode,
        val.countriesCode == "IN" ? defaultState : null,
        val.countriesCode == "IN" ? defaultCity : null,
        index ?? 0  
      );
    
     
        setValue?.("mobNo", "", {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        });
        setValue?.("whatsappNo", "", {
          shouldValidate: true,
          shouldDirty: true,
          shouldTouch: true,
        });
      
      if (inputName.includes("addressDetailsmobNo")) {
        dispatch(
          setContactMobNo({
            inputName: inputName,
            value: val.countryDialCodePrefix,
          })
        );
        setValue && setValue(`addressDetails[${index}].mobNo`, "");
        if (val.countriesCode != "IN") {
          setValue && setValue(`addressDetails[${index}].state`, null);
          setValue && setValue(`addressDetails[${index}].city`, null);
        }
      } else if (inputName.includes("mobNo")) {
        dispatch(
          setPhoneNo({
            inputName: "mobNo",
            value: val.countryDialCodePrefix,
          })
        );

        dispatch(
          setPhoneNo({
            inputName: "whatsappNo",
            value: val.countryDialCodePrefix,
          })
        );

        setValue && setValue("mobNo", "");
        setValue && setValue("whatsappNo", "");
      } else {
        dispatch(
          setPhoneNo({
            inputName: "whatsappNo",
            value: val.countryDialCodePrefix,
          })
        );

        setValue && setValue("whatsappNo", "");
      }

      setValue1(val);
    }
  };

  return (
    <MobileNoInputContainer>
      <label style={{ fontWeight: 600 }}>{labelName}</label>
      <div className="d-flex align-items-center position-relative">
        <div
          ref={inputRef}
          onClick={() => countryDropdownHandler()}
          className="country_container active"
        >
          <span>
            <img
              src={`${COUNTRY_CDN_URL}/${countryImage?.countryImageName || "in.svg"
                }`}
              className="img_flag"
            />
            <span className="dial-code">
              {"+" +
                (phoneNo?.prefixes && phoneNo?.prefixes[inputName]
                  ? phoneNo?.prefixes[inputName]
                  : "91")}
            </span>
          </span>
        </div>
        <div className="country_dropdown">
          {isOpen && (
            <SearchableDropdown
              isCountryDropdownOpen={isCountryDropdownOpen}
              setIsCountryDropdownOpen={setIsCountryDropdownOpen}
              placeholder="Search Country Name"
              options={countries}
              label1="countriesName"
              label2="countriesCode"
              label3="countryImageName"
              id="id"
              selectedVal={value1.countriesName}
              handleChange={(val) => handleMobileChange(val)}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              inputRef={inputRef}
            />
          )}
        </div>

        <Controller
          name={name}
          control={control}
          render={({ field }) => (
            <Input
              className="mobile_no_input"
              {...field}
              type="number"
              placeholder={placeHolder}
              onBlur={handleBlur}
              onKeyDown={(evt) =>
                ["e", "E", "+", "-", "."].includes(evt.key) &&
                evt.preventDefault()
              }
            />
          )}
        />
      </div>
    </MobileNoInputContainer>
  );
};

export default MobileNoInputField;